// Application constants

// Password for editing public sequences
export const PUBLIC_SEQUENCE_EDIT_PASSWORD = "P@ttern";